<div style="background-color: #eee">
    @if (!isEditing) {
        <div>
            <pre style="margin: 0; padding: 2px">{{ model | json }}</pre>
            <button
                class="m-btn m-btn-secondary"
                (click)="editObject()"
                style="padding-left: 0; background-color: transparent"
            >
                <app-svg-icon icon="edit"></app-svg-icon>
                {{ "form.edit" | translate }}
            </button>
        </div>
    }
    @if (isEditing) {
        <div style="display: grid">
            <textarea
                [(ngModel)]="jsonData"
                [rows]="getLineCount()"
                (input)="onInputChange($event)"
                style="
                    resize: none;
                    background-color: transparent;
                    font-family: monospace;
                    line-height: 1.5;
                    font-size: 0.8125rem;
                    border: none;
                    outline: none;
                "
            ></textarea>
            @if (!isValidJson) {
                <div style="color: red">Invalid JSON</div>
            }
            @if (isValidJson) {
                <button
                    class="m-btn m-btn-primary"
                    (click)="updateObject()"
                    style="width: max-content"
                >
                    <app-svg-icon icon="checkmark" />
                    {{ "form.ok" | translate }}
                </button>
            }
        </div>
    }
</div>
